import { Chip } from "$components/chip";
import type * as Types from "elephant-web/gql";
import { defineMessages, useIntl } from "react-intl";

interface Props {
  status: Types.InventoryMoveRequestStatus;
}

const messages = defineMessages({
  pending: {
    id: "inventory.moveRequests.status.pending",
    defaultMessage: "Pending",
  },
  rejected: {
    id: "inventory.moveRequests.status.rejected",
    defaultMessage: "Rejected",
  },
  fulfilled: {
    id: "inventory.moveRequests.status.fulfilled",
    defaultMessage: "Fulfilled",
  },
});

const StatusChip: FC<Props> = ({ status }) => {
  const { formatMessage } = useIntl();

  switch (status) {
    case "PENDING":
      return <Chip label={formatMessage(messages.pending)} color="disabled" />;
    case "REJECTED":
      return <Chip label={formatMessage(messages.rejected)} color="pink" />;
    case "FULFILLED":
      return <Chip label={formatMessage(messages.fulfilled)} color="brand" />;
    default:
      return null;
  }
};

export default StatusChip;
